module.exports = __webpack_public_path__ + "img/target.660b9b8.svg";